import React from 'react'
import AppBar from 'material-ui/AppBar'

const Navbar = () => {
    return (
        <AppBar title="Image Finder" />
    )
}

export default Navbar;